<template>
  <div class="container ml-container">
    <div class="box">
      <div class="search_box">
        <div class="search_title">品牌检索</div>
        <div class="search_input">
          <el-select
              v-model="value"
              filterable
              remote
              reserve-keyword
              placeholder="请输入品牌名称"
              :remote-method="remoteMethod"
              :loading="loading"
              class="search_select"
              @change="changeId"
              clearable
              @clear="clearInfo"
          >
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.brand_name"
                :value="item.id">
              <span>{{ item.brand_name || '' }}</span>
              <span style="float: right;font-size: 0.9em;font-weight: lighter">{{
                  item.co_customer_num ? '合作客户数：' + item.co_customer_num : '未合作'
                }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="search_btn">
          <el-button type="primary" @click="search()" icon="el-icon-search">搜索</el-button>
        </div>
      </div>
      <div class="brand">
        <!-- 品牌资料 -->
        <el-card class="brand_box" v-if="show_brand">
          <el-form ref="form" :model="brandForm">
            <el-row>
              <el-col :span="12">
                <el-form-item><a class="brand_box_name" @click="routerBrand">{{ brandForm.brand_name }}</a>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="历史合作客户：">{{ brandForm.co_customer_num }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="品牌首次录入时间：">{{ brandForm.first_entry_at }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="累计历史合作次数：">{{ brandForm.co_num }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <div v-if="userAuth.brand_search_sales_volume">
                  <el-form-item label="历史累计销售额：">{{ $utils.numberFormat(brandForm.sales_volume, 2) }}</el-form-item>
                </div>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上一年合作次数：">{{ brandForm.last_co_num }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <div v-if="userAuth.brand_search_sales_volume">
                  <el-form-item label="上一年累计销售额：">{{
                      $utils.numberFormat(brandForm.last_sales_volume, 2)
                    }}
                  </el-form-item>
                </div>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="最近一次合作销售：">{{ brandForm.last_sale_name }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最近一次合作时间：">{{ brandForm.last_co_at }}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="customer">
        <!-- 合作客户 -->
        <template v-if="show_customer">
          <!-- 分页 -->
          <div>
            <Pagination
                v-show="total>0"
                :total="total"
                :page.sync="query.page"
                :limit.sync="query.per_page"
                @pagination="handleQuery"
                :page-sizes="[3,5,10,15]"
            />
          </div>
          <el-card v-for="(item,index) in customerForm" :key="item.id" class="customer_box">
            <div>
              <div style="display: flex;align-items: center;justify-content: space-between">
                <h2 class="customer-name">
                  {{ index + 1 }}·{{ item.customer_name || ' - ' }}</h2>
                <div>更新时间：{{ item.updated_at }}</div>
              </div>
              <div class="customerInfo">
                <div class="customerInfo_left">累计历史合作次数：{{ item.co_num || ' - ' }}</div>
                <div v-if="userAuth.brand_search_sales_volume">历史累计销售额：{{
                    $utils.numberFormat(item.sales_volume, 2)
                  }}
                </div>
              </div>
              <div class="customerInfo">
                <div class="customerInfo_left">上一年合作次数：{{ item.last_co_num || ' - ' }}</div>
                <div v-if="userAuth.brand_search_sales_volume">
                  上一年累计销售额：{{ $utils.numberFormat(item.last_sales_volume, 2) }}
                </div>
              </div>
              <div>
                <div class="customerInfo">最近一次合作：{{ item.last_sale_name || ' - ' }}({{
                    item.last_co_at || ' - '
                  }})
                </div>
              </div>
              <div>
                <div class="customerInfo">关联销售：{{ item.related_sale_names || ' - ' }}</div>
              </div>
            </div>
          </el-card>
        </template>
        <!-- 分页 -->
        <div>
          <Pagination
              v-show="total>0"
              :total="total"
              :page.sync="query.page"
              :limit.sync="query.per_page"
              @pagination="handleQuery"
              :page-sizes="[3,5,10,15]"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {brandSearch, getBrandRecord, brandCustomerRecords} from '@/api/customerPool'

export default {
  name: 'searchResult',
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  data() {
    return {
      brandForm: {},
      customerForm: [],
      options: [],
      loading: false,
      value: null,
      query: {
        page: 1,
        per_page: 5,
        brand_record_id: null
      },
      show_customer: false,
      show_brand: false,
      total: 0,

    }
  },
  methods: {
    routerBrand() {
      //默认打开当前年份的品牌详情页面
      let date = new Date()
      const {href} = this.$router.resolve({
        name: `homeBrandDetail`,
        query: {brandName: this.brandForm.brand_name, year: date.getFullYear(), organization_id: 'ALL'}
      });
      window.open(href, '_blank')
      // location.href=href
    },
    remoteMethod(query) {
      this.options = [];
      const condition = {keyword: query}
      if (query !== '') {
        this.loading = true;
        //发起请求
        brandSearch(condition).then(res => {
          this.loading = false;
          this.options = res.data || []
        })
      }
    },
    //
    changeId() {
      //当前选择的品牌记录ID
      this.query.brand_record_id = this.value || null
      this.search()
    },
    search() {
      //从第1页开始查询
      this.query.page = 1;
      //品牌信息检索
      this.brandSearch()
      //品牌对应的客户信息检索
      this.handleQuery()
    },
    brandSearch() {
      this.brandForm = {}
      if (this.value) {
        getBrandRecord({id: this.value}).then(res => {
          this.brandForm = res.data || {}
        })
      }
    },
    handleQuery() {
      this.total = 0;
      this.customerForm = []
      if (this.query.brand_record_id) {
        brandCustomerRecords(this.query).then(res => {
          let data = res.data || {}
          this.customerForm = data.list || []
          this.total = data.total || 0
          this.query.page = data.current_page
          this.query.per_page = data.per_page
          this.show_customer = true
          this.show_brand = true
        })
      }
    },
    clearInfo() {
      this.show_customer = false
      this.show_brand = false
      this.brandForm = {}
      this.customerForm = []
      this.value = null
      this.options = []
      this.total = 0
    },
    // jumpToDetail(id) {
    //   const {href} = this.$router.resolve({
    //     name: `detailCustom`,
    //     query: {id: id}
    //   });
    //   window.open(href, "_blank");
    // }
  }
}
</script>

<style scoped>
.ml-container {
  width: 100% !important;
}

/*.container {*/
/*  display: flex;*/
/*  padding: 10px 10px;*/
/*  width: 100%;*/
/*}*/

.box {
  /*max-width: 1200px;*/
  width: 1000px;
  margin: auto;
  /*border: #3296Ff 1px solid;*/
  /*height: 100vh;*/
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.search_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px 0 0 0;
}

.search_title {
  font-size: 20px;
  font-weight: bold;
  color: #8a8e99;
  flex: auto;
}

.search_input {
  flex: auto;
}

.search_select {
  width: 800px
}

.search_btn {
  flex: auto;
}

.brand {
  width: 1000px;
  /*margin-bottom: 10px;*/
}

.brand_box {
  background-color: rgba(236, 234, 228, 0.93);
}

.brand_box .el-col-12 {
  height: 30px;
}

.brand_box_name {
  font-size: 30px;
  color: #ff3176;
  cursor: pointer;
}

.customer_box {
  width: 1000px;
  /*background-color: #dddddd;*/
  margin-bottom: 20px;
}

.customer-name {
  font-size: 26px;
  color: #ff3176;
  cursor: pointer;
  /*text-decoration: underline;*/
  text-decoration-color: #ff3176;
}

.customer-name:hover {
  font-size: 28px;
}

.customerInfo {
  display: flex;
  font-size: 14px;
}

.customerInfo_left {
  margin-right: 300px;
}
</style>
